import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Clock } from 'lucide-react';
import { apiFetch } from '../utils/api';
import { mapProductListItem } from '../store/slices/dressesSlice';
import ProductGrid from '../components/ProductGrid';

const NewArrivalPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    apiFetch('/api/public/marketing/new-arrivals/')
      .then(res => (res.ok ? res.json() : []))
      .then(data => {
        if (active) setProducts(Array.isArray(data) ? data.map(mapProductListItem) : []);
      })
      .catch(() => {
        if (active) setProducts([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-2 text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-primary-600 transition-colors">Store</Link>
        <span>/</span>
        <span className="text-gray-900 font-medium">New Arrival</span>
      </nav>

      {/* Header banner */}
      <div className="flex items-center gap-3 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-5 py-4 mb-6 shadow-sm">
        <div className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-5 h-5" />
        </div>
        <div>
          <h1 className="text-lg font-bold leading-tight">New Arrivals</h1>
          <p className="text-sm text-white/90 flex items-center gap-1.5 mt-0.5">
            <Clock className="w-3.5 h-3.5" />
            Our latest additions, fresh in stock.
          </p>
        </div>
      </div>

      {!loading && (
        <p className="text-sm text-gray-500 mb-5">
          {products.length > 0
            ? ''
            : 'No new arrivals right now'}
        </p>
      )}

      <ProductGrid
        products={products}
        loading={loading}
        listId="new-arrival"
        listName="New Arrival"
        startIndex={0}
      />
    </div>
  );
};

export default NewArrivalPage;
